import { API } from "../../Services";

export const orderSummary = (id) =>{
    return (dispatch) =>{
        dispatch({
            type:"FETCH_ORDER_SUMMARY",
        })
         API.orderSummary(id).then((res)=>{
            let data = JSON.parse(JSON.stringify(res)).data
            setTimeout(()=>{
                dispatch({
                    type:"RECEIVE_ORDER_SUMMARY",
                    payload:data,
                })
            },1000)
        }).catch((err)=>{
            dispatch({
                type:"ERROR_ORDER_SUMMARY",
            })
        })
    }
}